import React, { useState, useEffect, useRef } from 'react';
import EmojiPicker from 'emoji-picker-react';

const InlineEmojiPicker = ({ onEmojiClick }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [text, setText] = useState('');
  const containerRef = useRef(null);

  // Close picker when clicking outside of the picker or the button
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [showPicker]);

 /*  const onEmojiClick = (emojiData) => {
    // Append the native emoji character to your text state
    setText((prevText) => prevText + emojiData.emoji);
  }; */


  return (
    <div /* style={{ padding: '50px', fontFamily: 'sans-serif' }} */>
      {/* <h2>Emoji Picker Popup Example</h2> */}

      {/* Input Display */}
      {/* <input
        type="text"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Type something..."
        style={{ padding: '10px', fontSize: '16px', width: '300px', marginRight: '10px' }}
      /> */}

      {/* Picker Wrapper Container */}
      <div ref={containerRef} style={{ display: 'inline-block', position: 'relative' }}>
        {/* Trigger Button */}
        <button 
          type='button' // Prevents the form from submitting
          onClick={(e) => {
            e.preventDefault(); // Double protection againts form submissions
            setShowPicker((prev) => !prev);
          }}
          // style={{ padding: '10px 15px', fontSize: '16px', cursor: 'pointer' }}
        >
          😀
        </button>

        {/* Absolute Positioned Popup */}
        {showPicker && (
          <div className='emoji_picker_popup' /* style={{ position: 'absolute', bottom: '100%', right: 0, zIndex: 100, marginTop: '8px' }} */>
            <EmojiPicker  theme='dark' onEmojiClick={onEmojiClick} />
          </div>
        )}
      </div>
    </div>
  );
};

export default InlineEmojiPicker;